import * as React from 'react';
import * as Util from '../util';
import { Proposal2, ConsultantMultipleCVs } from '../pages/Proposal2';

import * as ClientProposal from '../client/Proposal';
import * as ClientHome from '../client/Home';

interface ProposalInfo extends Proposal2 {
    _id: string;
}

interface State {
    proposals: ProposalInfo[];
}

const toDate = (x: any): ProposalInfo => ({
    ...x,
    startDate: Util.date(x.startDate),
    endDate: Util.date(x.endDate)
});

export class CustomerProposals extends React.Component<object, State> {
    state: State = {
        proposals: []
    };
    async componentDidMount() {
        const proposals = (await ClientProposal.getProposal()).map(toDate);
        this.setState({proposals});
    }
    consultant(c: ConsultantMultipleCVs, i: number, consultantMeta: any) {
        const useFavicon = !consultantMeta.includePic;
        const cvsKey = consultantMeta.profileVersion ? consultantMeta.profileVersion.version : 'master';
        const summaryPoints = Util.paraSplit(c.cvs[cvsKey].summary).filter((s: string) => s.trim() !== '');
        const src = useFavicon || !c.profilePic ? '/favicon.ico' : ClientHome.profilePic(c.profilePic);
        return (
            <div className="row" key={i}>
                <div className="col-sm-3">
                    <div className="card" style={{height: '340px'}}>
                        <img
                            style={useFavicon ? {marginTop: '42.5px'} : undefined}
                            src={src}
                        />
                    </div>
                </div>
                <div className="col-sm-9">
                    <div className="card" style={{height: '340px'}}>
                        <div className="card-body">
                            <h2 className="card-title" style={{padding: 0}}>
                                {c.firstName} {c.lastName}
                            </h2>
                            <br />
                            <div className="ellipsis-block mb-3">
                                {summaryPoints.length > 1 ?
                                    (
                                        <ul>
                                            {summaryPoints.map((s: string, j: number) => (
                                                <li
                                                    className="mb-3"
                                                    key={j}
                                                >
                                                    {s}
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p>{summaryPoints}</p>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    profile(p: ProposalInfo, i: number) {
        const href = `/#/proposal3/${p._id}`;
        const consultant = p.consultants[0];
        const consultantMeta = consultant ? p.consultantMeta[consultant._id] : null;
        return (
            <div className="row" key={i}>
                <div className="col">
                    <a href={href}>
                        <h4>{p.proposalTitle}</h4>
                    </a>
                    <p>
                        {p.startDate ? Util.formatDate(p.startDate) : null}
                        to
                        {p.endDate ? Util.formatDate(p.endDate) : null}
                    </p>
                    <p>
                        {p.description}
                    </p>
                    {consultant ? this.consultant(consultant, 0, consultantMeta) : null}
                </div>
            </div>
        );
    }
    render() {
        const {proposals} = this.state;
        return (
            <div>
                <h5>Proposals</h5>
                {proposals.map((p, i) => this.profile(p, i))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/widgets/CustomerProposals.tsx